import { LoadScript } from '@react-google-maps/api'
import { ComponentType } from 'react'

export const GoogleMapsLoader: ComponentType = ({ children }) => {
  return (
    <LoadScript googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY} loadingElement={<div />}>
      {children}
    </LoadScript>
  )
}
